import { User } from 'src/types'
import objectToQueryString from 'src/helpers/object-to-query-string'

import api, { make, Response } from '.'

type Data = {
  total_results: number
  users: User[]
}

type GetAllProps = WithInactiveProp & {
  filter?: string
  page: number
  pageSize?: number
}

type GetByIdProps = WithInactiveProp & Pick<User, 'user_id'>

type SaveProps = {
  user: User
}

type WithInactiveProp = {
  withInactive?: boolean
}

export const PAGE_SIZE = 10

export function getAll({
  filter,
  page = 1,
  pageSize,
  withInactive = false
}: GetAllProps): Promise<Response<Data>> {
  const querystring = objectToQueryString({
    active: !withInactive || undefined,
    name: filter || undefined,
    page,
    page_size: pageSize || PAGE_SIZE
  })
  return make<Data>({
    axiosCall: api.get(`all/users${querystring}`)
  })
}

/**
 *
 * @param user_id User ID
 * @param withInactive to search inactive users
 * @returns returns only one user
 */
export function getById({
  user_id,
  withInactive = false
}: GetByIdProps): Promise<Response<User>> {
  return make<Data, User>({
    axiosCall: api.get(
      `all/users?user_id=${user_id}${withInactive ? '&active=True' : ''}`
    ),
    transformData: data => data.users[0]
  })
}

export function save({ user }: SaveProps): Promise<Response<User>> {
  return make<Pick<Data, 'users'>, User>({
    axiosCall: api.post(`users`, {
      users: [user]
    }),
    transformData: data => data.users[0]
  })
}
